import {EDocumentType, EPaymentType} from 'src/containers/User';

import {EDetailsAction, EEntityType} from './definitions';

export default {
  empty: 'Не указано',
  kpp: 'КПП',
  legalAddress: 'Юридический адрес',
  legalAddressHint: 'Введите адрес вашей компании, который будет указан в счете',
  postAddress: 'Почтовый адрес для документов',
  modalTitle: {
    companyDetails: 'реквизиты организации',
  },
  reminderModal: {
    title: 'Вы кое-что забыли',
    text: 'Нам не хватает данных о вашей компании. Пожалуйста, заполните реквизиты',
    button: 'Заполнить реквизиты',
    taxNumberWarning:
      'Пожалуйста, проверьте правильность ИНН. После сохранения поле будет закрыто для редактирования',
    vatNumberWarning:
      'Пожалуйста, проверьте правильность VAT number. После сохранения поле будет закрыто для редактирования',
    blrTaxNumberWarning:
      'Пожалуйста, проверьте правильность УНП. После сохранения поле будет закрыто для редактирования',
    binNumberWarning:
      'Пожалуйста, проверьте правильность Бизнес-идентификационного номера (БИН). После сохранения поле будет закрыто для редактирования',
    entityType: 'Тип компании',
    companyDetails: 'Реквизиты компании',
  },
  entityType: {
    [EEntityType.LEGAL]: 'Юридическое лицо',
    [EEntityType.INDIVIDUAL]: 'Индивидуальный предприниматель',
  },
  contractInfo: 'Данные договора и правила взаиморасчетов',
  countryCode: 'Страна',
  companyRequisites: 'Реквизиты организации',
  companyDetails: 'Данные компании',
  contactDetails: 'Контактное лицо клиента',
  settlementRules: 'Правила взаиморасчетов',
  licenseConditions: 'Условия подключения лицензий',
  country: 'Страна',
  taxNumber: 'ИНН',
  vatNumber: 'VAT number',
  blrTaxNumber: 'УНП',
  binNumber: 'Бизнес-идентификационный номер (БИН)',
  ogrn: 'ОГРН/ОГРНИП',
  currencyCode: 'Валюта',
  accountType: 'Тип аккаунта',
  documentType: 'Тип договора',
  documentTypes: {
    [EDocumentType.AGREEMENT]: 'Оферта',
    [EDocumentType.CONTRACT]: 'Бумажный договор',
    [EDocumentType.TECH_PARTNER_CONTRACT]: 'Техпартнер на договоре',
    [EDocumentType.TECH_PARTNER_OFFER]: 'Техпартнер на оферте',
    [EDocumentType.PILOT]: 'Пилот',
  },
  securityDeposit: 'Размер обеспечительного платежа',
  paymentType: 'Тип оплаты',
  paymentTypes: {
    [EPaymentType.MIXED_PREPAYMENT]: 'Смешанная оплата',
    [EPaymentType.POSTPAID]: 'Постоплата',
    [EPaymentType.PREPAYMENT]: 'Предоплата',
  },
  contactName: 'ФИО',
  phone: 'Телефон',
  email: 'Email',
  resellerId: 'Юрисдикция',
  maxOverdraft: 'Размер овердрафта',
  managerResponsibleForCheckingId: 'Ответственный за проверку компании',
  validity: 'Срок действия',
  activateLicenseDebt: 'Активация лицензии в долг',
  activateLicenseDebtOptions: {
    true: 'Разрешена',
    false: 'Запрещена',
  },
  licensePaymentTerm: 'Срок оплаты лицензии',
  termBeforeTerminationLicense: 'Срок до аннулирования лицензии при неоплате',
  overdraftAgreed: 'Овердрафт согласовал',
  companyName: 'Название организации',
  editContactInfo: 'Изменить контакты клиента?',
  editContactName: 'ФИО контактного лица компании',
  siteAddress: 'Сайт',
  detailsAction: {
    [EDetailsAction.ADD]: 'Дополнить {{detailsName}}',
    [EDetailsAction.FILL]: 'Заполнить {{detailsName}}',
    [EDetailsAction.UPDATE]: 'Редактировать {{detailsName}}',
  },
  notification:
    'Чтобы зарегистрировать каналы, полностью заполните реквизиты компании. Согласованные тарифы вы найдете на вкладке «Тарифы».',
};
